import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';
import TeamMember from '../fragments/TeamMember';

export default function Team({ block }) {

    const introRevealRef = useReveal({ once: true });
    const careersRevealRef = useReveal({ once: true });

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--team`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col l-grid__col--l-8-12 l-grid__col--l-push-4-12 c-transition-in l-bottom-section-space`} ref={introRevealRef}>
                    {block.heading &&
                        <h3 className="c-heading c-heading--accent">
                            <SpecialText text={block.heading} />
                        </h3>
                    }
                    {block.text &&
                        <p className="c-heading">
                            <SpecialText text={block.text} />
                        </p>
                    }
                </div>
                <div className="l-grid__col l-bottom-section-space">
                    <div className="c-team-grid">
                        {block.team && block.team.map((person, index) => (
                            <TeamMember key={index} person={person} />
                        ))}
                    </div>
                </div>
                {block.careers_text && (
                    <div className={`l-grid__col l-grid__col--l-8-12 c-transition-in`} ref={careersRevealRef}>
                        {block.careers_heading && (
                            <h3 className="c-heading c-heading--accent">
                                <SpecialText text={block.careers_heading} />
                            </h3>
                        )}
                        <p className="c-heading">
                            <SpecialText text={block.careers_text} />
                        </p>
                        {block.careers_button_text && block.careers_button_url && (
                            <div className="c-links l-small-top-space">
                                <SmartLink
                                    link={block.careers_button_url}
                                    className="c-links__link c-links__link--button"
                                >
                                    <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                    {block.careers_button_text}
                                </SmartLink>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}